import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { IFormModalProps } from '../../../models/forms/IForm';
import DefaultModal from '../../../shared-components/modal/default-modal';
import { formatMessage } from '../../../translations/format-message';
import EditActiveTrayDateForm from '../forms/edit-active-tray-date-form';
import { IActiveTrayFilter } from '../../../models/IActiveTrayFilter';

interface IProps extends IFormModalProps {
  orderProcessId: number;
  selectedDate: any;
  customerDueDate:any;
  filter: IActiveTrayFilter;
  selectedProcessName: string;
}

const EditActiveTrayDate = (props: IProps) => {
  const { activeTrayManagementStore } = useStore();

  const {
    UpdateProcessDueDateWithFilterService,
    updateProcessDueDateWithFilterState,
    resetUpdateProcessDueDateWithFilterState,
    recordsUpdated
  } = activeTrayManagementStore;

  useEffect(() => {
    if (updateProcessDueDateWithFilterState.success) {
      toast.success(`${recordsUpdated} ${formatMessage('trays_updated_success')}`);
      onModalClosed();
    }
  }, [updateProcessDueDateWithFilterState.success]);

  useEffect(() => {
    if (updateProcessDueDateWithFilterState.error) {
      toast.error(formatMessage(updateProcessDueDateWithFilterState.error));
      resetUpdateProcessDueDateWithFilterState();
    }
  }, [updateProcessDueDateWithFilterState.error]);

  const onSubmitForm = (values: any) => {
    UpdateProcessDueDateWithFilterService(
      props.orderProcessId,
      getddMMyyDateFormat(values.NewDate),
      props.filter
    )
    // UpdateProcessDueDatetService(
    //   "",
    //   Number(getTenantIdFromLocalStorage()),
    //   props.orderProcessId,
    //   getddMMyyDateFormat(values.NewDate)
    // );
    // props.modalClosed();
  };

  const getddMMyyDateFormat = (input: string): string => {
    const date = new Date(input);

    return (
      String(date.getDate()).padStart(2, '0') +
      String(date.getMonth() + 1).padStart(2, '0') +
      String(date.getFullYear()).slice(-2)
    );
  };

  const onModalClosed = () => {
    props.modalClosed();
  };


  return (
    <React.Fragment>
      <DefaultModal
        id={props.id}
        addHeader={`${formatMessage('change_date_for_process')} ${props.selectedProcessName}`}
        updateHeader={`${formatMessage('change_date_for_process')} ${props.selectedProcessName}`}
        onModalClosed={onModalClosed}
        isLoading={updateProcessDueDateWithFilterState.inProgress}
        className="modal-md"
      >
        <EditActiveTrayDateForm
          id={-1}
          initialValues={{ NewDate: props.selectedDate }}
          isLoading={updateProcessDueDateWithFilterState.inProgress}
          onModalClosed={onModalClosed}
          submitHandler={onSubmitForm}
          customerDueDate={props.customerDueDate}
        />
      </DefaultModal>
    </React.Fragment>
  );
};

export default observer(EditActiveTrayDate);
